import { StyleSheet } from 'react-native'
export { default as OSIcon } from '@expo/vector-icons/MaterialIcons'
export { default as MarkerIcon } from '@expo/vector-icons/Foundation'

export const styles = StyleSheet.create({
  attendancesContainer: {
    marginTop: 5
  },
  title: {
    fontWeight: '700',
    marginBottom: 8
  },
  titleAttendances: {
    fontWeight: '700',
    marginBottom: 8,
    fontSize: 12
  },
  attendancesText: {
    fontSize: 12
  }
})
